// One-tap return reasons — "why did this come back". Must match backend
// inventory/returns_scrap.py RETURN_REASONS. Free text only unlocks behind "Other".
export const RETURN_REASONS = [
  { code: "wrong_part", label: "Wrong part" },
  { code: "changed_mind", label: "Customer changed mind" },
  { code: "defective", label: "Defective" },
  { code: "damaged", label: "Damaged" },
  { code: "other", label: "Other" },
];

export const returnReasonLabel = (code) =>
  (RETURN_REASONS.find((r) => r.code === code) || {}).label || code;
